export enum ScheduleStatusTypeEnums {
  DAY_OFF = 0,
  PUBLISHED = 1,
  UNPUBLISHED = 2,
  SCHEDULED_ABSENCE = 3,
  HOLIDAY = 4,
}
